import React, { forwardRef } from 'react';
import styles from './styleConstants.module.css';

const cx = (base: string, extra?: string) =>
  extra ? `${base} ${extra}` : base;

type HeadingProps = React.ComponentPropsWithoutRef<'h1'>;
type ParagraphProps = React.ComponentPropsWithoutRef<'p'>;
type DivProps = React.ComponentPropsWithoutRef<'div'>;

export const H1 = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...rest }, ref) => (
    <h1 ref={ref} className={cx(styles.h1, className)} {...rest} />
  ),
);
H1.displayName = 'H1';

export const H1_OPT = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...rest }, ref) => (
    <h1 ref={ref} className={cx(styles.h1_opt, className)} {...rest} />
  ),
);
H1_OPT.displayName = 'H1_OPT';

export const H2 = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...rest }, ref) => (
    <h2 ref={ref} className={cx(styles.h2, className)} {...rest} />
  ),
);
H2.displayName = 'H2';

export const PLargeGradient = forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, ...rest }, ref) => (
    <p ref={ref} className={cx(styles.pLargeGradient, className)} {...rest} />
  ),
);
PLargeGradient.displayName = 'PLargeGradient';

export const H2_OPT = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...rest }, ref) => (
    <h2 ref={ref} className={cx(styles.h2_opt, className)} {...rest} />
  ),
);
H2_OPT.displayName = 'H2_OPT';

export const H2Small = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...rest }, ref) => (
    <h2 ref={ref} className={cx(styles.h2Small, className)} {...rest} />
  ),
);
H2Small.displayName = 'H2Small';

export const H3 = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...rest }, ref) => (
    <h3 ref={ref} className={cx(styles.h3, className)} {...rest} />
  ),
);
H3.displayName = 'H3';

export const P_OPT = forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, ...rest }, ref) => (
    <p ref={ref} className={cx(styles.p_opt, className)} {...rest} />
  ),
);
P_OPT.displayName = 'P_OPT';

export const PBody = forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, ...rest }, ref) => (
    <p ref={ref} className={cx(styles.pBody, className)} {...rest} />
  ),
);
PBody.displayName = 'PBody';

export const P = forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, ...rest }, ref) => (
    <p ref={ref} className={cx(styles.p, className)} {...rest} />
  ),
);
P.displayName = 'P';

export const PLarge = forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, ...rest }, ref) => (
    <p ref={ref} className={cx(styles.pLarge, className)} {...rest} />
  ),
);
PLarge.displayName = 'PLarge';

// Should be used only inside <Container>
export const LeftSideTextWrapper = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...rest }, ref) => (
    <div ref={ref} className={cx(styles.leftSideTextWrapper, className)} {...rest} />
  ),
);
LeftSideTextWrapper.displayName = 'LeftSideTextWrapper';
